/* eslint-disable */
import React, {Component} from 'react';
import Modal from 'react-modal';

import GroupContainer from "../../containers/group/GroupContainer";
import GroupFilter from "./GroupFilter";

export default class GroupList extends Component {
  constructor(props) {
    super(props);
    this.state = { modal: false }
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount() {
    this.props.didMount();
  }

  toggleModal(id) {
    return () => this.setState({ modal: id })
  }

  render() {
    const {modal} = this.state;
    return (
      <div>
        <GroupFilter toggleModal={this.toggleModal} {...this.props} />
        <Modal
          isOpen={!!modal}
          onRequestClose={this.toggleModal(false)}
          contentLabel="Modal"
        >
          <GroupContainer id={modal}/>
        </Modal>
      </div>
    )
  }
}
